import { ErrorHandler, inject, NgZone } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ErrorService } from "../services/error.service";
import { KlientloggerService } from "../services/klientlogger.service";
import { HbNotificationType, NotifyService } from "@husbanken/angular-starter";

export class HbErrorHandler implements ErrorHandler {
  private readonly errorService = inject(ErrorService);
  private readonly logService = inject(KlientloggerService);
  private readonly notifyService = inject(NotifyService);
  private readonly ngZone = inject(NgZone);
  private readonly translateService = inject(TranslateService);

  public handleError(error: any): void {
    // if (isDevMode() && !TestService.isRunningInTestContext) {
    //   throw error; // We want errors to be visible in the console when developing, without all the clutter which this handler brings...
    // }

    if (!error || (typeof error == "object" && !error?.name && !error?.message)) {
      return;
    }

    const httpStatusCode = error?.status ?? error?.rejection?.status;

    if (httpStatusCode) {
      this.ngZone.run(() =>
        this.notifyService.open({
          message: this.translateService.instant("En uventet feil har oppstått. Last applikasjonen på nytt hvis problemet vedvarer."),
          type: HbNotificationType.DESTRUCTIVE,
        }),
      );
    }

    this.errorService.newError(error);
    this.logService.error(error);
  }
}
